<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      a.button.btn.btn-default(v-if="channel && channelType === 'webEntryChannel'" :href="`/ssp/validator/${channel.alias}`") Show
      router-link.edit-entry-channel-button.btn.btn-default(v-if="isAdmin" :to="{name: 'entryChannelEdit', params: {id: channelId}}")
        i.fa.fa-edit
        span.ml5 Edit
      a.remove-entry-channel-button.btn.btn-danger(v-if="isAdmin" @click="deleteEntryChannel()")
        i.fa.fa-times
        span.ml5 Remove

    EntrychannelDetails(v-if="channel" :channel="channel" :codeConfig="channelCodeConfig" :loading="loading")

    GenericTable(v-if="channel && channel.translations.translation.length !== 0")
      tr(slot="thead")
        th Country
        th Invalid Message
      tr(v-for="t in channel.translations.translation")
        td {{t.country | countryName}}
        td {{t.invalidMessage}}

</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import { countryName } from '@/filters/filters'
import GenericTable from '@/components/common/GenericTable'
import auth from '@/service/AuthService'
import EntrychannelDetails from './EntrychannelDetails'

export default {
  data: () => ({
    loading: false,
    channel: null,
    channelCodeConfig: null,
    channelType: null
  }),
  methods: {
    deleteEntryChannel() {
      this.$confirm({ text: 'Are you sure you wish to delete in this entry channel?' })
        .then((conf) => {
          if (conf) {
            Core.deleteEntryChannel(this.channelId)
              .then(() => {
                miniToastr.success('Entry channel was successfully deleted')
                this.$router.push('/core/validation/entrychannels')
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    }
  },
  created() {
    Core.getEntryChannel(this.channelId)
      .then((resp) => {
        this.loading = true
        this.channel = resp.data.webEntryChannel || resp.data.smsEntryChannel

        if (resp.data.webEntryChannel) {
          this.channelType = 'webEntryChannel'
          this.channel.type = 'web'
        }
        if (!resp.data.webEntryChannel) {
          this.channelType = 'smsEntryChannel'
          this.channel.type = 'sms'
        }
        if (this.channel.codeConfig) {
          return this.channel.codeConfig.id
        }
      })
      .then((codeConfigId) => {
        if (codeConfigId) {
          Core.getCodeConfiguration(codeConfigId)
            .then((resp) => {
              this.channelCodeConfig = resp.data.name
            })
            .catch((e) => {
              this.$emit('error', e)
            })
        }
        this.loading = false
      })
      .catch((e) => {
        this.loading = false
        this.$emit('error', e)
      })
  },
  computed: {
    isAdmin() {
      if (auth.isAdmin()) {
        return true
      }
      return false
    },
    channelId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    EntrychannelDetails,
  },
  filters: {
    countryName
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/validation/entrychannel/Entrychannel.vue